import { Outlet, createFileRoute } from "@tanstack/react-router";

// Check ./workspaces/index.ts for route
export const Route = createFileRoute("/_authenticated/workspaces")({
  component: Outlet,
});
